import service from './service'

export default {
	//權限清單
	getOperationList: params => service.get(`back/role/getOperationList`),
	// 角色分頁
	getPage: params => service.post(`back/role/getPage`, params),
	// 角色簡易清單
	getAll: params => service.get(`back/role/getAll`),
	// 取得角色
	getDetail: params => service.get(`back/role/getDetail`, { params }),
	//新增角色
	add: params => service.post(`back/role/add`, params),
	//編輯角色
	update: params => service.put(`back/role/update`, params),
	//刪除角色
	remove: params => service.delete(`back/role/remove`, { params }),
}
